import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import MenuItems from './MenuItems';

const styles = {
  root: {
    flexGrow: 1,    
    },
  
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  AppBar: {
  background: 'linear-gradient(45deg, #36bff4  30%, #ebfffebd  50%)',
  opacity: .8,
  
  }
};


function ButtonAppBar(props) {
  const { classes } = props;
  
//  console.log(this.props.handleChange({ dynaFields: this.state.dynaFields }); );
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.AppBar}>
        <Toolbar>
          <MenuItems childProps={props}/>          
          <Typography variant="h6" className={classes.grow}>
            MicroKeyVault Mobile
          </Typography>
          <Button onClick={props.childProps.handleLogout}>Logout</Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);


// WEBPACK FOOTER //
// ./src/components/ButtonAppBar.jsx